import { useQuery, UseQueryResult } from 'react-query'

import { ApiError } from '@src/Core/Models/ApiError'
import { getTracking } from '@src/Infrastructure/Connectors/GetTracking/getTracking'
import {
    GetTrackAndTraceError,
    GetTrackAndTraceParams,
    GetTrackAndTraceResponse,
} from '@src/Infrastructure/Types/GetTrackAndTrace'

export const queryFn = (params: GetTrackAndTraceParams) => async (): Promise<GetTrackAndTraceResponse> => {
    const result = await getTracking(params)

    if ('errors' in result) {
        throw new ApiError(result.errors[0].code)
    }

    return result
}

export const getCacheKey = (params: GetTrackAndTraceParams) => ['tracking', params.shipmentId] as const

export type UseGetTracking = (
    params: GetTrackAndTraceParams
) => UseQueryResult<GetTrackAndTraceResponse, ApiError<GetTrackAndTraceError>>

export const useGetTracking: UseGetTracking = (params) => {
    return useQuery({
        queryFn: queryFn(params),
        queryKey: getCacheKey(params),
        enabled: false,
        retry: false,
    })
}
